__turbopack_context__.v({
  "attachmentNotice": "uKklDG_attachmentNotice",
  "checkboxField": "uKklDG_checkboxField",
  "emailSuggestion": "uKklDG_emailSuggestion",
  "expandable": "uKklDG_expandable",
  "fieldWithSuggestion": "uKklDG_fieldWithSuggestion",
  "fields": "uKklDG_fields",
  "fileUploadWrapper": "uKklDG_fileUploadWrapper",
  "form": "uKklDG_form",
  "honeypot": "uKklDG_honeypot",
  "privacy": "uKklDG_privacy",
  "privacyLink": "uKklDG_privacyLink",
  "replyPromise": "uKklDG_replyPromise",
  "spin": "uKklDG_spin",
  "spinner": "uKklDG_spinner",
  "submitButton": "uKklDG_submitButton",
});
